import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import FoulTypeServices from "./foul_type.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getFoulType = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FOUL_TYPE,
      payload: true,
    });
    const resp = await FoulTypeServices.getFoulType(filters);
    dispatch({
      type: actions.GET_FOUL_TYPE,
      payload: {
        foulType: resp.data.data,
        foulTypeLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.FOUL_TYPE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FOUL_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FOUL_TYPE,
      payload: false,
    });
  }
};

export const saveFoulType = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_FOUL_TYPE,
      payload: true,
    });
    const resp = await FoulTypeServices.saveFoulType(data);
    const { foulType, foulTypeLength } = getState().foulType;
    const aFoulType = [...foulType, resp.data];
    dispatch({
      type: actions.GET_FOUL_TYPE,
      payload: {
        foulType: aFoulType,
        foulTypeLength: foulTypeLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_FOUL_TYPE,
      payload: false,
    });
  }
};

export const editFoulType = (data, id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_FOUL_TYPE,
      payload: true,
    });
    const resp = await FoulTypeServices.editFoulType(id, data);
    const { foulType, foulTypeLength } = getState().foulType;
    foulType[index] = resp.data;
    dispatch({
      type: actions.GET_FOUL_TYPE,
      payload: {
        foulType: foulType,
        foulTypeLength: foulTypeLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FOUL_TYPE,
      payload: false,
    });
  }
};

export const deleteFoulType = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_FOUL_TYPE,
      payload: true,
    });
    await FoulTypeServices.deleteFoulType(id);
    const { foulType, foulTypeLength } = getState().foulType;
    foulType.splice(index, 1);
    dispatch({
      type: actions.GET_FOUL_TYPE,
      payload: {
        foulType: foulType,
        foulTypeLength: foulTypeLength - 1,
      },
    });
    dispatch({
      type: actions.FOUL_TYPE_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FOUL_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FOUL_TYPE,
      payload: false,
    });
  }
};
